import React, { useState } from 'react';
import ButtonLarge from '../components/Button-large';
import '../css/Contact.css';
import { MdSend, MdCheck } from 'react-icons/md';



const ContactForm = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await fetch('https://chunksbakes.com/contact.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    
    const result = await res.json();
    
    if (result.success) {
      setSubmitted(true);
    } else {
      alert('There was an error sending your message.');
    }
  } catch (err) {
    alert('There was an error sending your message.');
  }
};

  return (
    
     
      <div className="contact-page">
        {submitted ? (
          <div className="contact-success">
            <MdCheck className="contact-success-icon" size={48} />
            <div className='contact-success-text'>
            <h3>Thank you for your message!</h3>
            <p>We'll get back to you shortly.</p>
            </div>
            </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-input"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea
                id="message"
                name="message"
                className="form-textarea"
                value={form.message}
                onChange={handleChange}
                required
                rows={6}
              />
            </div>
            <div className="form-actions">
              <ButtonLarge
                type="submit"
                label="Send message"
                className="form-submit-btn"
                icon={() => <MdSend className="animated-icon" />} // Animated icon
              />
            </div>
          </form>
          
        )}
      </div>
      




      
      

  );
};

export default ContactForm;